import { sinatraOrigin } from '../../config'

import keycloakService from '../../keycloak_service'

import { getTimeRange } from '../date_utils';

import { ALL_TIME } from '../../components/admin/orchestrations/OrchestrationTableFilterModal/OrchestrationTableFilterModal';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const listTaskRuns = (id, timeRange, taskRunStatus) => {
  const body = {
    task_id: id
  }

  if (timeRange && timeRange?.type !== ALL_TIME ) {
    body.time_range = getTimeRange(timeRange);
  }

  if (taskRunStatus && taskRunStatus !== 'all') {
    body.status = taskRunStatus.toLowerCase();
  }
  
  const fetchOptions = {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify(body)
  }

  return postToApi('v1/api/task/list_task_runs', fetchOptions)
}

// Wrapper for SWR Fetch Function
export const swrTaskRunListFetcher = (queryParams) => {
  const [taskIds, timeRange, taskRunStatus] = queryParams;

  const fetchArrayOfTaskRuns = taskIds.map(id => listTaskRuns(id, timeRange, taskRunStatus))

  return Promise.all(fetchArrayOfTaskRuns);
}

export default listTaskRuns
